import React, { useState, useEffect } from 'react';
import { useRef } from 'react';
import axios from 'axios';
import Paper from '@mui/material/Paper';
import SearchIcon from '@mui/icons-material/Search';
import * as XLSX from 'xlsx';
import { fetchData, updateData, deleteData, activateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { IconButton } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import FeedIcon from '@mui/icons-material/Feed';
import Select from 'react-select'; // Import react-select
import CopyrightIcon from '@mui/icons-material/Copyright';
import CircularProgress from '@mui/material/CircularProgress';
import { Box } from '@mui/material';
import CreateIcon from '@mui/icons-material/Create';
import AddIcon from '@mui/icons-material/Add';
import InfoIcon from '@mui/icons-material/Info';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import { Tooltip } from '@mui/material';
import {
    Checkbox, Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow, TableSortLabel, TablePagination, TableFooter
} from '@mui/material';
import Modal from '@mui/material/Modal';
import { Button } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useLocation, Link } from 'react-router-dom';
import AsyncSelect from 'react-select/async';


function CustomerRegister() {

    const [dataItem, setDataItem] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    const tableRef = React.createRef();
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [isFocused, setIsFocused] = useState(false);
    const { isAuthenticated, companyId, branchId, permissions, token, logout } = useAuth();

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        setFromDate(getFormattedStartDate());
        setToDate(getFormattedCurrentDate());
        fetchTableData();
    }, [isAuthenticated, companyId, token, branchId, logout]);


    const getFormattedCurrentDate = () => {
        const currentDate = new Date();
        return currentDate.toISOString().split('T')[0];
    };


    const getFormattedStartDate = () => {
        const monthStartDate = new Date();
        monthStartDate.setDate(1);
        return monthStartDate.toISOString().split('T')[0];
    };


    // const fetchTableData = async () => {
    //     setDataItem([]); // Reset data
    //     try {
    //         const response = await fetchData(
    //             'ReportApi',
    //             `/CustomerRegister/${companyId}/${branchId}/${fromDate}/${toDate}`,
    //             token
    //         );
    //         if (response.responseCode === '1111') {
    //             setDataItem(response.response_data);
    //         }
    //     } catch (error) {
    //         console.error('Error fetching Customer Details:', error);
    //     }
    // };

    const fetchTableData = async () => {

        setDataItem([])
        try {
            const response = await fetchData('ReportApi', `/CustomerRegsiter/${fromDate}/${toDate}/${companyId}/${branchId}`, token);

            if (response.responseCode === '1111') {
                setDataItem(response.response_data);

            }
        } catch (error) {
            console.error('Error fetching Packing Slip Details:', error);
        }

    };

    const handleFromDateChange = (e) => {
        const selectedDate = e.target.value;
        // Add validation if needed
        setFromDate(selectedDate);
    };

    // Similar function for toDate
    const handleToDateChange = (e) => {
        const selectedDate = e.target.value;
        // Add validation if needed
        setToDate(selectedDate);
    };


    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    const filteredDataItem = dataItem.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        return new Date(dateString).toLocaleDateString('en-GB', options);
    };

    const handleExportExcel = () => {
        const excelData = [];

        // Add a title row or caption (optional)
        const headerCaption = ['Customer Registration Details'];
        excelData.push(headerCaption);

        // Define the header row based on your provided column names
        const headerRow = [
            'Customer Name',
            'Email',
            'Contact Number',
            'Address Line 1',
            'Address Line 2',
            'Address Proof Type',
            'Address Proof No',
            'Room No',
            'Purpose',
            'Check-In Date',
            'Check-Out Date',
            'Check-In Time',
            'Check-Out Time',
            'Total Stay',
            'Rent Amount',
            'Discount',
            'Final Amount',
        ];
        excelData.push(headerRow);

        // Add data rows
        filteredDataItem.forEach((rowData) => {
            const dataRow = [
                rowData.CustomerName,
                rowData.Email,
                rowData.ContactNumber,
                rowData.AddressLine1,
                rowData.AddressLine2,
                rowData.AddressProofType,
                rowData.AddressProofNo,
                rowData.RoomNo,
                rowData.Purpose,
                formatDate(rowData.CheckIn), // Format Check-In Date
                formatDate(rowData.CheckOut), // Format Check-Out Date
                rowData.CheckInTime,
                rowData.CheckOutTime,
                rowData.TotalStay,
                rowData.RentAmount,
                rowData.Discount,
                rowData.FinalAmount,
            ];
            excelData.push(dataRow);
        });

        // Convert the array to a worksheet
        const ws = XLSX.utils.aoa_to_sheet(excelData);

        // Create a workbook and append the worksheet
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Customer Registration');

        // Save the workbook as an Excel file
        XLSX.writeFile(wb, 'Customer_Registration_Details.xlsx');
    };


    const [page, setPage] = useState(0); // Current page
    const [rowsPerPage, setRowsPerPage] = useState(15); // Rows per page

    // Define initial column order
    const [columnOrder, setColumnOrder] = useState([
        'Name',
        'Email',
        'Ph No',
        'Address 1',
        'Address 2',
        'ID Type',
        'ID No',
        'Room',
        'Purpose',
        'CheckIn',
        'CheckOut',
        'Check-In Time',
        'Check-Out Time',
        // 'Stay',
        // 'Rent',
        // 'Discount',
        // 'Final',

    ]);

    // Handle page change
    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    // Handle rows per page change
    const handleRowsPerPageChange = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0); // Reset to the first page
    };

    // Function to handle drag start
    const handleDragStart = (e, index) => {
        e.dataTransfer.setData('columnIndex', index);
    };

    // Function to handle drag over
    const handleDragOver = (e) => {
        e.preventDefault(); // Allow drop
    };

    // Function to handle drop
    const handleDrop = (e, index) => {
        const draggedIndex = e.dataTransfer.getData('columnIndex');
        if (draggedIndex !== index) {
            const newOrder = [...columnOrder];
            // Swap columns
            [newOrder[draggedIndex], newOrder[index]] = [newOrder[index], newOrder[draggedIndex]];
            setColumnOrder(newOrder);
        }
    };


    const grandTotal = filteredDataItem.reduce(
        (totals, rowData) => {
            const fieldsToSum = [
                "TotalStay",
                "RentAmount",
                "Discount",
                "FinalAmount"
            ];

            fieldsToSum.forEach((field) => {
                totals[field] = parseFloat(
                    (totals[field] + (parseFloat(rowData[field]) || 0)).toFixed(2)
                );
            });

            return totals;
        },
        {
            TotalStay: 0,
            RentAmount: 0,
            Discount: 0,
            FinalAmount: 0
        }
    );

    console.log(grandTotal);


    // Process and paginate the data
    const processedData = filteredDataItem.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
    );


    return (

        <div className="w-full  mx-auto" style={{ width: '100%', marginTop: '-1%' }}>
            <br></br>

            <div className='w-full mb-2 flex' style={{ marginTop: '10px' }}>
                {/* Title */}
                <h6
                    className="uppercase tracking-wide text-black flex-grow linkcolor"
                    style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}
                >
                    CUSTOMER REGISTER
                </h6>

                {/* Search Bar */}
                <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'left', marginTop: '5px' }}>
                    <input
                        className="shadow text-gray-700 leading-tight"
                        type="text"
                        placeholder="Search..."
                        value={searchQuery}
                        onChange={handleSearch}
                        onFocus={() => setIsFocused(true)}
                        onBlur={() => setIsFocused(false)}
                        style={{
                            width: isFocused ? '270px' : '200px',
                            height: '40px',
                            border: '1px solid #ccc',
                            borderRadius: '15px',
                            padding: '0 20px',
                            transition: 'width 0.4s ease-in-out, border-color 0.3s ease-in-out',
                            outline: 'none',
                            borderColor: isFocused ? 'darkcyan' : '#ccc',
                            boxShadow: isFocused ? '0 4px 8px rgba(0, 0, 0, 0.2)' : 'none',

                        }}
                    />
                </div>

                <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '10px', marginTop: '-10px' }}>
                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                        From Date
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        type="date" value={fromDate} onChange={handleFromDateChange}
                        style={{ marginTop: '-10px', shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                    />
                </div>
                <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '10px', marginTop: '-10px' }}>
                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                        To Date
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        type="date" value={toDate} onChange={handleToDateChange}
                        style={{ marginTop: '-10px', shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                    />
                </div>

                <Tooltip
                    title="Refresh For Data Load"
                    componentsProps={{
                        tooltip: {
                            sx: {
                                backgroundColor: 'darkolivegreen',
                                color: 'white',
                                border: '1px solid white',
                                fontWeight: 'bold',
                                boxShadow: 2,
                            },
                        },
                    }}
                >
                    <Button
                        style={{ backgroundColor: '#C9E9D2', color: "black", height: '36px', marginLeft: '10px', marginTop: '10px' }}
                        onClick={fetchTableData}
                        className="linkcolor"
                    >
                        <span>Refresh</span>
                    </Button>
                </Tooltip>

                <Tooltip
                    title="Export to Excel"
                    componentsProps={{
                        tooltip: {
                            sx: {
                                backgroundColor: '#F2DEDE',
                                color: 'black',
                                border: '1px solid white',
                                fontWeight: 'bold',
                                boxShadow: 2,
                            },
                        },
                    }}
                >
                    <Button
                        style={{ backgroundColor: '#F2DEDE', color: "black", height: '36px', marginLeft: '10px', marginTop: '10px' }}
                        onClick={handleExportExcel}
                        className="linkcolor"
                    >
                        <span>EXCEL</span>
                    </Button>
                </Tooltip>

            </div>
            <div className='w-full mb-5 flex' style={{ maxHeight: '540px', overflowY: 'auto', marginTop: '-0.20%' }}>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead sx={{ backgroundColor: 'whitesmoke', width: '2500px' }}>
                            <TableRow>
                                {columnOrder.map((col, index) => (
                                    <TableCell
                                        key={index}
                                        style={{ padding: '6px', cursor: 'move', color: '#640D5F', fontWeight: 'bold' }}
                                        draggable
                                        onDragStart={(e) => handleDragStart(e, index)}
                                        onDragOver={handleDragOver}
                                        onDrop={(e) => handleDrop(e, index)}
                                    >
                                        {col}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>


                        <TableBody>
                            {processedData
                                .map((rowData, index) => {
                                    const rowValues = {
                                        'Name': rowData.CustomerName || '',
                                        'Email': rowData.Email || '',
                                        'Ph No': rowData.ContactNumber || '',
                                        'Address 1': rowData.AddressLine1 || '',
                                        'Address 2': rowData.AddressLine2 || '',
                                        'ID Type': rowData.AddressProofType || '',
                                        'ID No': rowData.AddressProofNo || '',
                                        'Room': rowData.RoomNo || '',
                                        'Purpose': rowData.Purpose || '',
                                        'CheckIn': rowData.CheckIn ? formatDate(rowData.CheckIn) : '',
                                        'CheckOut': rowData.CheckOut ? formatDate(rowData.CheckOut) : '',
                                        'Check-In Time': rowData.CheckInTime || '',
                                        'Check-Out Time': rowData.CheckOutTime || '',

                                    };
                                    return (
                                        <TableRow
                                            key={rowData.Id || index}

                                        >
                                            {columnOrder.map((col, idx) => (
                                                <TableCell
                                                    key={idx}
                                                    sx={{
                                                        borderBottom: '1px solid #E4E0E1',
                                                        padding: '5px',
                                                        backgroundColor:
                                                            col === 'Check-In Time' && rowData.CheckInTime ? '#E0F7FA' :
                                                                col === 'Check-Out Time' && rowData.CheckOutTime ? '#FFEBEE' :
                                                                    'transparent', // Default background
                                                        color:
                                                            col === 'Check-In Time' && rowData.CheckInTime ? '#00695C' :
                                                                col === 'Check-Out Time' && (rowData.CheckOutTime === '' || rowData.CheckOutTime === undefined)
                                                                    ? '#B71C1C' : // Red color for "Not Updated"
                                                                    col === 'Check-Out Time' && rowData.CheckOutTime ? '#B71C1C' :
                                                                        'inherit', // Default text color
                                                    }}
                                                >
                                                    {col === 'Check-Out Time' && (rowData.CheckOutTime === '' || rowData.CheckOutTime === undefined)
                                                        ? <span style={{ color: '#B71C1C' }}>Not Updated</span>
                                                        : rowValues[col]}
                                                </TableCell>
                                            ))}

                                            {/* {columnOrder.map((col, idx) => (
                                                <TableCell
                                                    key={idx}
                                                    sx={{
                                                        borderBottom: '1px solid #E4E0E1',
                                                        padding: '5px',
                                                        backgroundColor:
                                                            col === 'Check-In Time' && rowData.CheckInTime ? '#E0F7FA' :
                                                                col === 'Check-Out Time' && rowData.CheckOutTime ? '#FFEBEE' :
                                                                    'transparent',
                                                        color:
                                                            col === 'Check-In Time' && rowData.CheckInTime ? '#00695C' :
                                                                col === 'Check-Out Time' && rowData.CheckOutTime ? '#B71C1C' :
                                                                    'inherit',
                                                    }}
                                                >
                                                    {rowValues[col]}
                                                </TableCell>
                                            ))} */}
                                        </TableRow>
                                    );
                                })}

                        </TableBody>

                        <TableRow
                            key="Total"
                            sx={{ backgroundColor: '#F3F3F3', fontWeight: 'bold' }}
                        >
                            {columnOrder.map((col, idx) => {
                                let cellStyle = {};
                                let cellValue = '';

                                if (col === 'TotalStay') {
                                    cellValue = grandTotal.TotalStay;
                                    cellStyle = { backgroundColor: '#DFF0D8' };
                                } else if (col === 'RentAmount') {
                                    cellValue = grandTotal.RentAmount;
                                    cellStyle = { backgroundColor: '#F3F3F3' };
                                } else if (col === 'Discount') {
                                    cellValue = grandTotal.Discount;
                                    cellStyle = { backgroundColor: '#F3F3F3' };
                                } else if (col === 'FinalAmount') {
                                    cellValue = grandTotal.FinalAmount;
                                    cellStyle = { backgroundColor: '#F2DEDE' };
                                }
                                return (
                                    <TableCell key={idx} style={{ padding: '7px', ...cellStyle }}>
                                        {cellValue}
                                    </TableCell>
                                );
                            })}
                        </TableRow>

                        {/* Render Grand Total in Footer */}
                        <TableFooter style={{ padding: '5px' }}>
                            <TableRow>
                                <TablePagination
                                    rowsPerPageOptions={[15, 25, 50, 100]}
                                    count={filteredDataItem.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handlePageChange}
                                    onRowsPerPageChange={handleRowsPerPageChange}

                                />
                            </TableRow>


                        </TableFooter>
                    </Table>
                </TableContainer>
            </div>
        </div >
    );
    function descendingComparator(a, b, orderBy) {
        if (b[orderBy] < a[orderBy]) {
            return -1;
        }
        if (b[orderBy] > a[orderBy]) {
            return 1;
        }
        return 0;
    }

    function getComparator(order, orderBy) {
        return order === 'desc'
            ? (a, b) => descendingComparator(a, b, orderBy)
            : (a, b) => -descendingComparator(a, b, orderBy);
    }

    function stableSort(array, comparator) {
        const stabilizedThis = array.map((el, index) => [el, index]);
        stabilizedThis.sort((a, b) => {
            const order = comparator(a[0], b[0]);
            if (order !== 0) return order;
            return a[1] - b[1];
        });
        return stabilizedThis.map((el) => el[0]);
    }




}
export default CustomerRegister;